<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Debtors List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row dense>
          <v-col
            v-show="userRole != 1"
            cols="7"
            class="subtitle-2 text--primary mt-1"
            >Total Debt: {{ totalDebt }}</v-col
          >

          <v-col cols="12" sm="12" md="7">
            <!-- excel icon -->
            <download-excel :data="debtors" :fields="fields" name="Debtors">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="userRole == 1 ? cashierHeaders : headers"
              :items="debtors"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- details template -->
              <template v-slot:item.ocrd.Name="{ item }">
                <v-btn
                  text
                  color="primary"
                  :to="`/statement/customer/${item.ocrd.id}`"
                >
                  {{ item.ocrd.Name }}
                </v-btn>
              </template>
              <!-- end of details -->
              <!-- template -->
              <template v-slot:item.Balance="{ item }">
                <span style="color: red">{{
                  item.Balance.toLocaleString()
                }}</span>
              </template>
              <!-- end -->

              <!-- details template -->
              <template v-slot:item.details="{ item }">
                <v-btn icon :to="`/report/debtors/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end of details -->

              <!-- details template -->
              <template v-slot:item.message="{ item }">
                <v-btn color="green" icon @click="messageModal(item)">
                  <v-icon>mdi-message-processing</v-icon>
                </v-btn>
              </template>
              <!-- end of details -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- message dialog -->
        <v-dialog v-model="messageDialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Debt Reminder</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="messageDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="subtitle-2 text--primary">
                  <v-col cols="12">
                    <h4>
                      Are you sure you want to send the following reminder?
                    </h4>
                  </v-col>
                  <v-col cols="12" v-if="debtItem"
                    >Customer: {{ debtItem.Name }}</v-col
                  >
                  <v-col cols="12" v-if="debtItem.Balance"
                    >Current Debt:
                    {{ debtItem.Balance.toLocaleString() }}</v-col
                  >

                  <v-col cols="12">
                    <v-textarea
                      v-model="message"
                      outlined
                      Label="Custom Message"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="6">
                    <v-btn
                      color="accent"
                      @click="sendMessage"
                      :loading="loader"
                    >
                      <v-icon left>mdi-arrow-right-circle</v-icon> Yes
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-card>
        </v-dialog>

        <!-- clearing debt dialog -->
        <v-dialog v-model="dialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Record Debt Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="subtitle-2 text--primary">
                  <v-col cols="12">Customer: {{ customer.Name }}</v-col>
                  <v-col cols="12">Current Debt: {{ totalDebtValue }}</v-col>
                  <v-col cols="6" xs="6">
                    <v-text-field
                      name="debtorAmountToClear"
                      v-model="amount"
                      label="Amount Paid"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">New Bal: {{ newBalance }}</v-col>
                  <v-col cols="12" xs="12" md="6" sm="6">
                    <v-autocomplete
                      name="debtorPaymentMode"
                      dense
                      outlined
                      v-model="accountId"
                      :items="accounts"
                      label="Payment Mode"
                      item-text="Name"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" md="6" sm="6">
                    <DatePicker
                      @date="setDate"
                      :myDate="date"
                      :title="`Date`"
                    ></DatePicker>
                  </v-col>
                  <v-col cols="6">
                    <v-btn color="accent" @click="save" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon>Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-card>
        </v-dialog>
        <!-- end -->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    zeroValue: 0,
    search: "",
    pageItems: 1000,
    messageDialog: false,
    message: null,
    debtItem: {},
    accountId: null,
    dialog: false,
    customer: {},
    Balance: null,
    amount: null,
    accounts: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Name", value: "ocrd.Name" },
      // { text: "Phone Number", value: "PhoneNumber" },
      { text: "Current Debt", value: "Balance" },
      { text: "Details", value: "details" },
    ],
    cashierHeaders: [
      { text: "Name", value: "ocrd.Name" },
      // { text: "Phone Number", value: "PhoneNumber" },
      { text: "Action", value: "action" },
      { text: "Details", value: "details" },
      { text: "Message", value: "message" },
    ],
    fields: {
      Debtor: "ocrd.Name",
      Balance: "Balance",
    },
    debtors: [],
    Debt: null,
  }),
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
    totalDebt() {
      let total = 0;
      if (this.Debt) {
        total = this.Debt.toLocaleString();
      }
      return total;
    },
    totalDebtValue() {
      let total = 0;
      if (this.Balance) {
        total = this.Balance.toLocaleString();
      }
      return total;
    },
    newBalance() {
      let amountPaid;
      let newBalance;
      if (this.amount) {
        amountPaid = parseFloat(this.amount);
        newBalance = this.Balance - amountPaid;
      } else {
        amountPaid = 0;
        newBalance = this.Balance - amountPaid;
      }
      return newBalance.toLocaleString();
    },
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    messageModal(data) {
      this.debtItem = data;
      this.messageDialog = true;
    },
    sendMessage() {
      const url = "/debt-reminder";
      const data = this.debtItem;
      data.message = this.message;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.debtItem = {};
            self.message = null;
            self.loader = false;
            self.messageDialog = false;
            self.$refs.snackbar.show("Message Sent", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openDialog(val) {
      const self = this;
      this.$store
        .dispatch("get", `/customers/${val.id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.Balance = res.ResponseData.Balance;
            self.customer = res.ResponseData;
            self.dialog = true;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDebtors() {
      const self = this;
      this.$store
        .dispatch("get", `/debtors`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.debtors = res.ResponseData.Debtors;
            self.Debt = res.ResponseData.TotalDebt;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const self = this;
      const data = {
        CardCode: self.customer.id,
        DocDate: self.date,
        o_a_c_t_s_id: self.accountId,
        SumApplied: self.amount,
      };
      if (this.accountId == null || this.amount == null) {
        this.$refs.snackbar.show("Account or amount missing!", "red");
      } else {
        const url = "/incoming-payments";
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              location.reload();
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
  },
  created() {
    this.getDebtors();
    this.getAccounts();
  },
};
</script>